<template>
  <div>
    <div
      v-if="isLoading"
      class="text-center p-5"
    >
      <CSpinner
        style="width:2rem;height:2rem;"
        color="info"
        grow
      />
    </div>
    <CDataTable
      v-else
      small
      border
      sorter
      column-filter
      :items="chargeReceipts"
      :fields="fields"
      :sorter-value="{ column: 'paymentDate', asc: false }"
      :items-per-page="10"
      :pagination="{ align: 'center' }"
    >
      <template #paymentDate="{ item }">
        <td class="text-nowrap">
          {{ formatDateTime(item.paymentDate) }}
        </td>
      </template>

      <template #amount="{ item }">
        <td class="text-right">
          {{ formatAmount(item.amount) }}
        </td>
      </template>

      <template #cardType="{ item }">
        <td>
          <CIcon
            v-if="getCardIcon(item.cardType)"
            :name="getCardIcon(item.cardType)"
            size="xl"
            :style="{ color: getCardColor(item.cardType) }"
          />
          <span v-else>{{ item.cardType ? item.cardType.toUpperCase() : '' }}</span>
        </td>
      </template>

      <template #actions="{ item }">
        <td>
          <CButton
            size="sm"
            color="info"
            variant="outline"
            @click="downloadReceipt(item.transactionId)"
          >
            Download
          </CButton>
        </td>
      </template>
    </CDataTable>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { formatAmount, formatDateTime } from '@/utils'

export default {
  name: 'BuyerCreditCardCharges',

  props: {
    accountId: {
      type: String,
      required: true
    },

    lazyLoad: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isLoading: false,
      fields: [
        { key: 'paymentDate', label: 'Date' },
        { key: 'amount', label: 'Amount', _classes: 'text-right' },
        { key: 'transactionDescription', label: 'Description' },
        { key: 'cardType', label: 'Card Type' },
        { key: 'lastCreditCardDigits', label: 'Last 4 Digits' },
        { key: 'actions', label: 'Actions', sorter: false, filter: false }
      ]
    }
  },

  computed: {
    ...mapState('creditCards', ['chargeReceipts'])
  },

  async created() {
    if (!this.lazyLoad) {
      await this.loadChargeReceipts()
    }
  },

  methods: {
    ...mapActions('creditCards', ['getChargeReceipts']),
    ...mapActions('billing', ['generateDownloadLink']),

    async loadChargeReceipts() {
      try {
        this.isLoading = true
        await this.getChargeReceipts(this.accountId)
      } catch (e) {
        //
      } finally {
        this.isLoading = false
      }
    },

    async downloadReceipt(transactionId) {
      const downloadURL = await this.generateDownloadLink({
        accountId: this.accountId,
        invoiceId: transactionId
      })
      window.open(downloadURL)
    },

    getCardIcon(cardType) {
      if (!cardType) {
return null
}

      const type = cardType.toLowerCase()
      const iconMap = {
        visa: 'cib-cc-visa',
        master: 'cib-cc-mastercard',
        mastercard: 'cib-cc-mastercard',
        amex: 'cib-cc-amex',
        'american express': 'cib-cc-amex',
        american_express: 'cib-cc-amex',
        discover: 'cib-cc-discover'
      }
      return iconMap[type] || null
    },

    getCardColor(cardType) {
      if (!cardType) {
return null
}

      const type = cardType.toLowerCase()
      const colorMap = {
        visa: '#1A1F71',
        master: '#EB001B',
        mastercard: '#EB001B',
        amex: '#006FCF',
        'american express': '#006FCF',
        american_express: '#006FCF',
        discover: '#FF6000'
      }
      return colorMap[type] || null
    },

    formatAmount,
    formatDateTime
  }
}
</script>
